import { takeLatest } from 'redux-saga/effects';
import { handleSubmitPanNumber, handleSavePanImage, handleConfirmPan } from './panDetailsFormHandlers';
import { savePanImage, verifyPanNumber, confirmPan } from './panDetailsFormSlice';

export function* savePanImageSaga() {
  yield takeLatest(savePanImage.type, handleSavePanImage);
}

export function* submitPanNumberSaga() {
  yield takeLatest(verifyPanNumber.type, handleSubmitPanNumber);
}
export function* confirmPanSaga() {
  yield takeLatest(confirmPan.type, handleConfirmPan);
}
